import { captureCanvasCard } from "./captureSnapshots";

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

/** Capture just the 2 snapshots needed for the investor one-pager */
export async function captureInvestorSnapshots({ setView, setActiveFloor, setPreset }) {
  const out = {};
  // Hero 3D view (isometric — most flattering massing)
  setView("3d"); setActiveFloor(1); setPreset("isometric");
  await sleep(1200);
  out.hero3d = await captureCanvasCard();
  // Site plan
  setView("site");
  await sleep(800);
  out.site = await captureCanvasCard();
  return out;
}
